import axios from 'axios'
import {getApiUrls,getApiUpdateUrls} from "@/http/base.http";

export function getAssetList(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}asset/list/get`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function addAssetList(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}asset/list/add`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function getByIdAssetList(id) {
    const { env } = getApiUrls();
    return axios.get(`${env}asset/list/detail/${id}`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function updateAssetList(payload) {
    const {envU } = getApiUpdateUrls();
    return axios.put(`${envU}asset/list/update`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}